import type { FertilizerOperator } from '../../types'

import type { Action } from 'fc-flow-types/redux'

import { put, call } from 'redux-saga/effects'

// Operator
import operator from '../operator'

import { validateModel } from 'fc-model-fertilizers'

export default function *validateOperationSaga (operation: FertilizerOperator): Generator<*, *, *> {
  const errors = yield call(validateModel, operation.model)

  if (errors.length) {
    const nextOperation = {
      ...operation,
      submitting: false,
      errors,
    }

    const action: Action<Object> = yield operator.actionCreators.updateOperation(nextOperation)

    yield put(action)

    return nextOperation
  }

  return {
    ...operation,
    errors,
  }
}
